import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronRight } from 'lucide-react'
import { navigationDomainForPath, navigationItemForPath } from '@/components/layout/_navigation'
import Sidebar from './Sidebar'
import TopBar from './TopBar'

export default function AppShell() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <div className="flex min-h-[calc(100vh-4rem)]">
        <Sidebar />
        <main className="min-w-0 flex-1 overflow-y-auto px-4 py-7 sm:px-6 lg:px-8 lg:py-8">
          <PageContextHeader />
          <div className="min-w-0">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

function PageContextHeader() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const item = navigationItemForPath(pathname)
  const domain = navigationDomainForPath(pathname)

  if (!item || !domain) return null

  return (
    <header className="mb-7 max-w-4xl">
      <nav
        aria-label={t('pageHeader.breadcrumbLabel')}
        className="mb-3 flex items-center gap-1.5 text-sm text-muted-foreground"
      >
        <span>{domain.key === 'overview' ? t('sidebar.title') : t(domain.labelKey)}</span>
        <ChevronRight className="size-3" aria-hidden="true" />
        <span aria-current="page" className="text-foreground/80">
          {t(item.labelKey)}
        </span>
      </nav>
      <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{t(item.labelKey)}</h1>
    </header>
  )
}
